/* @jsx h */
import { defineComponent, h } from "vue";
import { PageComponent, useLocalization } from "@lemmonhq/uikit";

export const GroupLoyaltyPage = defineComponent({
  name: "GroupLoyaltyPage",
  setup() {
    const { t } = useLocalization();

    return () => (
      <PageComponent
        title={t("nav.labels.loyalty")}
        titleIcon="loyalty"
        subpages={[
          {
            name: t("group.loyalty.memberships_title"),
            icon: "card_membership",
            href: "/group/loyalty/memberships",
          },
          {
            name: t("group.loyalty.coins_title"),
            icon: "toll",
            href: "/group/loyalty/coins",
          },
          {
            name: t("promotions.wallet.page_title"),
            icon: "wallet",
            href: "/group/loyalty/wallet",
          },
          {
            name: t("group.loyalty.automations_title"),
            icon: "bolt",
            href: "/group/loyalty/automations",
          },
        ]}
      />
    );
  },
});

export * from "./subpages/MembershipPrograms";
export * from "./subpages/CoinPrograms";
export * from "./subpages/WalletDesigns";
export * from "./subpages/Automations";
